<template>
  <div>
    <el-button
      type="primary"
      size="small"
      plain
      @click="handleBind"
      :disabled="disabled"
      :loading="loading"
      >绑定抖音号</el-button
    >
    <el-dialog title="授权" :visible.sync="showDialog" width="900px">
      <div class="content">
        <div class="mask"></div>
        <iframe
          v-if="showDialog"
          class="iframe"
          :src="authUrl"
          frameborder="0"
        />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getTiktokCode, tiktokCodeState } from "@/api/team";
export default {
  props: {
    classId: String,
    disabled: Boolean,
  },
  data() {
    return {
      loading: false,
      authUrl: "",
      showDialog: false,
      authCode: "",
    };
  },
  watch: {
    showDialog(val) {
      this.timer && clearInterval(this.timer);
      if (val) {
        this.timer = setInterval(this.verCode, 2000);
      }
    },
  },
  methods: {
    handleBind() {
      this.$confirm("即将打开授权页，确定要绑定吗？", {
        type: "warning",
      })
        .then(() => {
          this.$loading.show();
          getTiktokCode({ classId: this.classId }).then(
            ({ code, data, msg }) => {
              this.$loading.hide();
              if (code == 0) {
                this.authUrl = data.url;
                this.authCode = data.code;
                this.showDialog = true;
                // this.timer && clearInterval(this.timer);
                // this.timer = setInterval(() => {
                //   this.verCode(data.code);
                // }, 3000);

                // window.open(data.url);
              } else {
                this.$message.error(msg);
              }
            }
          );
        })
        .catch(() => {});
    },
    // 验证授权码状态
    verCode() {
      tiktokCodeState({ code: this.authCode }).then(({ code, data, msg }) => {
        if (code == 0) {
          if (data == 3) {
            this.$message.success("授权成功");
            this.$emit("onSuccess");
            this.showDialog = false;
            // clearInterval(this.timer);
          } else if (!data) {
            this.$message.warning("二维码已失效");
            this.showDialog = false;
          }
        } else {
          console.log(msg);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.content {
  position: relative;

  .iframe {
    width: 100%;
    height: 60vh;
  }

  .mask {
    position: absolute;
    top: 15%;
    right: 10%;
    bottom: 0;
    height: 40vh;
    width: 40%;
    background-color: #fff;
  }
}
</style>
